export default __webpack_public_path__ + "static/media/Cab by night (1).cbf5d153.png";